export const getOverlayContainer = (): HTMLElement | null => {
  if (typeof document !== "undefined") {
    return document.getElementById("overlay-root");
  }
  return null;
};
